import { Outlet } from "react-router-dom";

const LocalBazaarRoot = () => {
  return (
    <div>
      <Outlet/>
    </div>
  );
};

export default LocalBazaarRoot;